import React from 'react';

interface Review {
  reviewerName: string;
  project: string;
  timeAgo: string;
  rating: number;
  comment: string;
  avatarUrl?: string;
}

interface ReviewsSummaryProps {
  reviews: Review[];
  isMobile?: boolean;
  isDesktop?: boolean;
}

const ReviewsSummary: React.FC<ReviewsSummaryProps> = ({ reviews, isMobile, isDesktop }) => {
  const renderStars = (currentRating: number) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (currentRating >= i) {
        stars.push(<span key={i} className="material-symbols-outlined text-xs" data-icon="star" style={{ fontVariationSettings: "'FILL' 1" }}>star</span>);
      } else {
        stars.push(<span key={i} className="material-symbols-outlined text-xs" data-icon="star">star</span>);
      }
    }
    return stars;
  };

  if (isMobile) {
    return (
      <section className="px-container-margin mt-stack-xl space-y-stack-lg md:hidden">
        <div className="flex justify-between items-center">
          <h3 className="font-headline-sm text-headline-sm text-primary">Recent Feedback</h3>
          <div className="flex items-center gap-2">
            <span className="font-label-bold">Filter by:</span>
            <select className="border-outline-variant rounded-md font-label-md py-1 bg-surface-container-low focus:ring-primary">
              <option>Most Recent</option>
              <option>Highest Rated</option>
            </select>
          </div>
        </div>
        <div className="space-y-gutter">
          {reviews.map((review, index) => (
            <div key={index} className="p-4 bg-surface rounded-xl border border-outline-variant/20 space-y-3">
              <div className="flex justify-between items-start">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-slate-200">
                    {review.avatarUrl && <img src={review.avatarUrl} alt="Avatar" className="w-full h-full rounded-full object-cover" />}
                  </div>
                  <div>
                    <p className="font-label-bold">{review.reviewerName}</p>
                    <p className="text-[10px] text-on-surface-variant">{review.project} • {review.timeAgo}</p>
                  </div>
                </div>
                <div className="flex text-amber-400">
                  {renderStars(review.rating)}
                </div>
              </div>
              <p className="font-body-md text-on-surface-variant italic">"{review.comment}"</p>
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (isDesktop) {
    return (
      <section className="bg-surface-container-lowest rounded-xl shadow-sm p-stack-lg border border-outline-variant space-y-stack-lg hidden md:block">
        <div className="flex justify-between items-center">
          <h3 className="font-headline-sm text-headline-sm text-primary">Recent Feedback</h3>
          <div className="flex items-center gap-2">
            <span className="font-label-bold">Filter by:</span>
            <select className="border-outline-variant rounded-md font-label-md py-1 bg-surface-container-low focus:ring-primary">
              <option>Most Recent</option>
              <option>Highest Rated</option>
            </select>
          </div>
        </div>
        <div className="space-y-gutter">
          {reviews.map((review, index) => (
            <div key={index} className="p-4 bg-surface rounded-xl border border-outline-variant/20 space-y-3">
              <div className="flex justify-between items-start">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-slate-200">
                    {review.avatarUrl && <img src={review.avatarUrl} alt="Avatar" className="w-full h-full rounded-full object-cover" />}
                  </div>
                  <div>
                    <p className="font-label-bold">{review.reviewerName}</p>
                    <p className="text-[10px] text-on-surface-variant">{review.project} • {review.timeAgo}</p>
                  </div>
                </div>
                <div className="flex text-amber-400">
                  {renderStars(review.rating)}
                </div>
              </div>
              <p className="font-body-md text-on-surface-variant italic">"{review.comment}"</p>
            </div>
          ))}
        </div>
      </section>
    );
  }

  return null;
};

export default ReviewsSummary;